<p>modal-1 works!</p>

<div class="actions m-t--20">
  <button type="button" class="btn btn-outline-primary m-t-20" (click)="skipModal()">{{ 'generic.cancel' | cxTranslate }}</button>

  <button type="button" class="btn btn-outline-primary m-t-20" (click)="closeModal()">{{ 'generic.close' | cxTranslate }}</button>

  <button type="button" class="btn btn-primary m-t-20" (click)="openModal2()">Open Modal 2</button>
</div>
